import { useContext } from 'react';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';

function Parse(num) {
  var showCurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showValWhenEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var branding = arguments.length > 3 ? arguments[3] : undefined;
  var decimalRequired = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  var trauncateFractionAndFormat = function trauncateFractionAndFormat(parts, digits) {
    return parts.map(function (_ref) {
      var type = _ref.type,
          value = _ref.value;

      if (type !== 'fraction' || !value || value.length < digits) {
        return value;
      }

      var retVal = '';

      for (var idx = 0, counter = 0; idx < value.length && counter < digits; idx++) {
        counter++;
        retVal += value[idx];
      }

      return retVal;
    }).reduce(function (string, part) {
      return string + part;
    });
  };

  var ParseWithBranding = function ParseWithBranding() {
    var _Intl$NumberFormat, _Intl$NumberFormat2;

    var _useContext = useContext(ConfigContext),
        branding = _useContext.branding;

    return !showValWhenEmpty && (num == null || num == undefined || (num === null || num === void 0 ? void 0 : num.toString()) === '') ? null : "".concat(showCurrency ? branding.currency + ' ' : '').concat(decimalRequired ? trauncateFractionAndFormat((_Intl$NumberFormat = new Intl.NumberFormat((branding === null || branding === void 0 ? void 0 : branding.currency) === '₹' ? 'en-IN' : undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 20
    })) === null || _Intl$NumberFormat === void 0 ? void 0 : _Intl$NumberFormat.formatToParts(num), 2) : trauncateFractionAndFormat((_Intl$NumberFormat2 = new Intl.NumberFormat((branding === null || branding === void 0 ? void 0 : branding.currency) === '₹' ? 'en-IN' : undefined, {
      maximumFractionDigits: 0
    })) === null || _Intl$NumberFormat2 === void 0 ? void 0 : _Intl$NumberFormat2.formatToParts(num), 2) // ? numeral(num).format('0,0.00')
    // : numeral(num).format('0,0')
    );
  };

  if (branding) {
    var _Intl$NumberFormat3, _Intl$NumberFormat4;

    return !showValWhenEmpty && (num == null || num == undefined || (num === null || num === void 0 ? void 0 : num.toString()) === '') ? null : "".concat(showCurrency ? branding.currency + ' ' : '').concat(decimalRequired ? trauncateFractionAndFormat((_Intl$NumberFormat3 = new Intl.NumberFormat((branding === null || branding === void 0 ? void 0 : branding.currency) === '₹' ? 'en-IN' : undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 20
    })) === null || _Intl$NumberFormat3 === void 0 ? void 0 : _Intl$NumberFormat3.formatToParts(num), 2) : trauncateFractionAndFormat((_Intl$NumberFormat4 = new Intl.NumberFormat((branding === null || branding === void 0 ? void 0 : branding.currency) === '₹' ? 'en-IN' : undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    })) === null || _Intl$NumberFormat4 === void 0 ? void 0 : _Intl$NumberFormat4.formatToParts(num), 2) // ? numeral(num).format('0,0.00')
    // : numeral(num).format('0,0')
    );
  } else {
    return ParseWithBranding();
  }
}

export { Parse as P };
